export default {
      id: "amount-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#amount",
      toString: function () {
        return this.url;
      }
    }